<div>
  @if (verified) {
    <span><fa-icon [icon]="['fas', 'check']" class="check" /></span>
  }
  @if (!verified && rejected) {
    <div class="rejected"><strong>REJECTED</strong></div>
  }
  <span [ngClass]="{ rejected: !verified && rejected }">
    @if (submission) {
      {{ submission.submittedAt | date: 'MM/dd/yyyy' }} by {{ submission.submittedBy.fullName }}
    }
  </span>
</div>
